import { render } from "./CommentAdSense.vue?vue&type=template&id=5fa887b6&scoped=true"
import script from "./CommentAdSense.vue?vue&type=script&lang=js"
export * from "./CommentAdSense.vue?vue&type=script&lang=js"

import "./CommentAdSense.vue?vue&type=style&index=0&id=5fa887b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa887b6"]])

export default __exports__